import { Link, useRouteError } from 'react-router';
import { Button, EmptyState } from '@/components/ui';
import { isCodeLoadError } from './codeLoadError';

export function RouteError() {
  const error = useRouteError();
  console.error(error);
  if (isCodeLoadError(error)) {
    return (
      <div style={{ padding: 32 }}>
        <EmptyState
          title="Part of the app could not load"
          action={
            <>
              <Button variant="primary" onClick={() => window.location.reload()}>
                Reload
              </Button>
              <Link to="/">Go to the start page</Link>
            </>
          }
        >
          <p>
            A new version of the app may have been published since this page was opened, or the
            connection dropped. Reloading opens the current version. Your saved projects are not
            affected.
          </p>
        </EmptyState>
      </div>
    );
  }
  return (
    <div style={{ padding: 32 }}>
      <EmptyState
        title="Something went wrong on this page"
        action={<Link to="/">Go to the start page</Link>}
      >
        <p>
          Your saved projects are not affected. If you were editing, your last save on this device
          is kept.
        </p>
      </EmptyState>
    </div>
  );
}

export function NotFound() {
  return (
    <div style={{ padding: 32 }}>
      <EmptyState title="Page not found" action={<Link to="/">Go to the start page</Link>} />
    </div>
  );
}

/** Shown while a route's code loads on a direct visit (for example a bookmarked studio link). */
export function RouteLoading() {
  return (
    <p role="status" style={{ padding: 32, textAlign: 'center', color: 'var(--color-muted)' }}>
      Loading…
    </p>
  );
}
